import React from "react";
import { roles } from "../../constants/roles";

const RoleFilter = ({ value, onChange, className = "" }) => {
  return (
    <select className={`form-control ${className}`} value={value} onChange={onChange}>
      <option value="all">Tous les rôles</option>
      {roles.map((role) => (
        <option key={role.value} value={role.value}>
          {role.label}
        </option>
      ))}
    </select>
  );
};

export default RoleFilter;
